import React, { useContext, useEffect, useState } from 'react';
import CircularProgressBar from './CircularProgressBar';
import { CircularProgress } from '@material-ui/core';
import GoogleMapsLoader from './GoogleMapsLoader';


import {
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Container,
  Grid,
} from '@material-ui/core';
import '../assets/styles/NewCMAPage.css';
import Step1 from './Step1';
import Step2 from './Step2/Step2';
import Step3 from './Step3';
import Step4 from './Step4/Step4';
import { CMAContext } from './CMAContext';
import { useLocation } from 'react-router';
import { ContactsContext } from './ContactsContext';
import Breadcrumb from './BreadcrumbsComponent';
import { useHistory } from 'react-router-dom';
import api, {consoleDevLog} from '../apiConfig';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';

const NewCMAPage = () => {
  const location = useLocation();
  const [client, setClient] = useState(location.state ? location.state.clientName : '');

  consoleDevLog('Client Name:', client);

  const { cmas, addCMA, updateCMA } = useContext(CMAContext);
  const { updateClientResources } = useContext(ContactsContext);
  const [loading, setLoading] = useState(false); // State to track loading

  const [currentStep, setCurrentStep] = useState(1);
  const [cmaName, setCmaName] = useState('');
  const [subjectProperty, setSubjectProperty] = useState(null);
  const [priceRange, setPriceRange] = useState({ min: '', max: '' });
  const [homeFeatures, setHomeFeatures] = useState('');
  const [realtorComments, setRealtorComments] = useState('');
  const [selectedHomes, setSelectedHomes] = useState([]);
  const [finalSelectedHomes, setFinalSelectedHomes] = useState([]);
  const [adjustments, setAdjustments] = useState({});
  const { cmaData } = location.state || {};

  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [popupTitle, setPopupTitle] = useState('');

  const [generateModalOpen, setGenerateModalOpen] = useState(false);
  const [overrideSubjectPropertyNum, setOverrideSubjectPropertyNum] = useState(false);

  // Add effect to log state changes
  useEffect(() => {
    consoleDevLog('overrideSubjectPropertyNum changed to:', overrideSubjectPropertyNum);
  }, [overrideSubjectPropertyNum]);

  const handleOpenGenerateModal = () => {
    setGenerateModalOpen(true);
  };

  const handleCloseGenerateModal = () => {
    setGenerateModalOpen(false);
  };

  const history = useHistory();

  useEffect(() => {
    if (cmaData) {
      consoleDevLog(cmaData);
      setClient(cmaData.client);
      setCmaName(cmaData.cmaName);
      setSubjectProperty(cmaData.subjectProperty);
      setSelectedHomes(cmaData.selectedHomes);
      setFinalSelectedHomes(cmaData.finalSelectedHomes);
      setAdjustments(cmaData.adjustments);
    }
  }, [cmaData]);

  const handleNextStep = () => {
    if (currentStep === 2 && finalSelectedHomes.length === 0) {
      setPopupTitle('Selection Required');
      setPopupMessage('You must select at least one comparable home before proceeding.');
      setPopupOpen(true); // Show popup if no homes are selected in Step 2
    } else if (currentStep === 3 && finalSelectedHomes.length === 0) {
      // setPopupTitle('Final Selection Required');
      // setPopupMessage('You must confirm at least one final comparable home before proceeding.');
      // setPopupOpen(true); // Show popup if no homes are selected in Step 3
    } else {
      setCurrentStep((prevStep) => prevStep + 1); // Proceed to next step
    }
  };

  const handlePreviousStep = () => {
    setCurrentStep((prevStep) => prevStep - 1);
  };

  const handleClosePopup = () => {
    setPopupOpen(false);
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <Step1
            currentStep={currentStep}
            client={client}
            cmaName={cmaName}
            subjectProperty={subjectProperty}
            setClient={setClient}
            setCmaName={setCmaName}
            setSubjectProperty={setSubjectProperty}
            handleNextStep={handleNextStep}
            handlePreviousStep={handlePreviousStep}
            setOverrideSubjectPropertyNum={setOverrideSubjectPropertyNum}
          />
        );
      case 2:
        return (
          <Step2
            subjectProperty={subjectProperty}
            currentStep={currentStep}
            selectedHomes={selectedHomes}
            setSelectedHomes={setSelectedHomes}
            finalSelectedHomes={finalSelectedHomes}
            setFinalSelectedHomes={setFinalSelectedHomes}
            handlePreviousStep={handlePreviousStep}
            setCurrentStep={setCurrentStep}
          />
        );
      case 3:
        return (
          <Step3
            subjectProperty={subjectProperty}
            currentStep={currentStep}
            selectedHomes={selectedHomes}
            finalSelectedHomes={finalSelectedHomes}
            setFinalSelectedHomes={setFinalSelectedHomes}
            adjustments={adjustments}
            setAdjustments={setAdjustments}
            setCurrentStep={setCurrentStep}
            overrideSubjectPropertyNum={overrideSubjectPropertyNum}
          />
        );
      case 4:
        return (
          <Step4
            subjectProperty={subjectProperty}
            currentStep={currentStep}
            selectedHomes={selectedHomes}
            finalSelectedHomes={finalSelectedHomes}
            realtorComments={realtorComments}
            setRealtorComments={setRealtorComments}
            priceRange={priceRange}
            setPriceRange={setPriceRange}
            adjustments={adjustments}
            generateModalOpen={generateModalOpen}
            onCloseGenerateModal={handleCloseGenerateModal}
            updateClientResources={updateClientResources}
            history={history}
            cmaData={cmaData}
          />
        );
      default:
        return null;
    }
  };

  const firstStep = currentStep === 1;

  return (
      <Container maxWidth={false}>
        <Grid container spacing={3}>
          <Breadcrumb />
        </Grid>

        <div className="new-cma-page-container">
          <div
            className="navigation-bar"
            style={{ justifyContent: firstStep ? 'center' : 'space-between' }}
          >
            {currentStep !== 1 && (
              <Button
                variant="contained"
                color="secondary"
                className={`previous-button ${firstStep ? 'hidden' : ''}`}
                onClick={handlePreviousStep}
              >
                Previous
              </Button>
            )}
            <CircularProgressBar currentStep={currentStep} />
            {/* Conditionally render the Next button */}
            {currentStep > 1 && currentStep < 4 ? (
              <Button
                variant="contained"
                color="primary"
                className="next-button"
                onClick={handleNextStep}
              >
                Next
              </Button>
            ) : currentStep === 4 ? (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Button
                  variant="contained"
                  color="primary"
                  className="generate-report-button"
                  onClick={handleOpenGenerateModal}
                  disabled={loading} // Disable the button while loading
                >
                  {loading ? <CircularProgress size={24} /> : 'Generate'}{' '}
                  {/* Show spinner while loading */}
                </Button>

                {loading && (
                  <Typography style={{ marginLeft: '10px' }}>Generating CMA...</Typography>
                )}
              </div>
            ) : null}
          </div>
          {renderStep()}
        </div>

        <Dialog open={popupOpen} onClose={handleClosePopup}>
          <DialogTitle>{popupTitle}</DialogTitle>
          <DialogContent>{popupMessage}</DialogContent>
          <DialogActions>
            <Button onClick={handleClosePopup} color="primary">
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
  );
};

export default NewCMAPage;
